import { useLocation } from "react-router-dom";
import PaymentResult from "../../components/PaymentResult/PaymentResult";

function PaymentSuccess() {
    const { state } = useLocation();
    const skipped = state?.payload?.status === "confirmed_without_deposit";

    return (
        <PaymentResult
            tone="success"
            title={skipped ? "Appointment Confirmed" : "Payment Successful"}
            message={skipped ? "The appointment is confirmed. No deposit was charged; the full balance is due after the appointment." : "The deposit has been charged and the appointment is confirmed."}
            appointment={state?.appointment}
        />
    );
}

export default PaymentSuccess;